export enum Platform {
    iPhone = "iphone",
    iPad = "ipad",
}
